import React from "react";
import loader from "../../../../assets/images/spinner.gif";

export const Loader = () => (
  <span id="login_loader" className="login_loader" style={{ display: "block" }}>
    <img title="Loading..." alt="Loading..." src={loader} />
  </span>
);
